import { ref, uploadBytes, getDownloadURL } from "firebase/storage"
import { avatarStorage } from "../firebase"

export const uploadAvatar = async (userId: string, avatar: File) => {
  const storageRef = ref(avatarStorage, `users/${userId}/avatar`)

  try {
    const result = await uploadBytes(storageRef, avatar)
    console.info(`Avatar uploaded to users/${userId}/avatar`, result)
  } catch (error) {
    console.error("Failed to upload avatar", error)
    throw error
  }
}

export const getAvatarDownloadUrl = async (userId: string) => {
  const storageRef = ref(avatarStorage, `users/${userId}/avatar`)

  try {
    return await getDownloadURL(storageRef)
  } catch (error) {
    if (error.code !== "storage/object-not-found") {
      console.error("Failed to get avatar download link", error)
    }
    return null
  }
}
